export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7205.4b1c2a10.jpg";